import {useState,useEffect} from 'react';
import {api} from '../lib/api';

const defaults={action:'save_finding',category:'age_assurance',scenario:'underage',
 harm:'',affected_persons:'',severity:'critical',likelihood:'high',mitigation:'',
 evidence:'',residual_risk:'high',outcome:'open',owner:'',due_date:'',review_notes:''};

export default function ProfilesStaffRiskAssessment(){
 const [records,setRecords]=useState([]);
 const [risk,setRisk]=useState(defaults);
 const [scenario,setScenario]=useState('underage');
 const [status,setStatus]=useState('');
 const [error,setError]=useState('');
 const [busy,setBusy]=useState(false);
 const [preview,setPreview]=useState([]);
 const [remoteAssets,setRemoteAssets]=useState([]);
 const [remoteFile,setRemoteFile]=useState(null);
 const [remoteBusy,setRemoteBusy]=useState(false);
 const [remoteError,setRemoteError]=useState('');
 const [remoteStatus,setRemoteStatus]=useState('');
 const [opened,setOpened]=useState(null);
 useEffect(()=>()=>{if(opened?.url)URL.revokeObjectURL(opened.url);},[opened]);
 const loadRemote=async()=>{
   try{
     const res=await fetch('/api/profiles/risk-media',{credentials:'same-origin',cache:'no-store'});
     const data=await res.json().catch(()=>null);
     if(!res.ok||!data?.staffOnly||!Array.isArray(data.assets))
       throw Error(data?.code||'Private storage is unavailable');
     setRemoteAssets(data.assets);setRemoteError('');
   }catch(e){setRemoteAssets([]);setRemoteError('Real private storage: '+(e.message||'Unavailable'));}
 };
 useEffect(()=>{void loadRemote();},[]);
 const uploadRemote=async()=>{
   if(!remoteFile)return;
   if(remoteFile.size>8*1024*1024){setRemoteError('The testing limit is 8 MB per file.');return;}
   setRemoteBusy(true);setRemoteError('');setRemoteStatus('');
   try{
     const res=await fetch('/api/profiles/risk-media',{method:'POST',credentials:'same-origin',
       headers:{'content-type':remoteFile.type},body:remoteFile});
     const body=await res.json().catch(()=>null);
     if(!res.ok||body?.success!==true)throw Error(body?.code||'Upload failed');
     setRemoteStatus('Stored privately on the actual Profiles media backend. Public access remains disabled.');
     setRemoteFile(null);await loadRemote();
   }catch(e){setRemoteError('Upload failed: '+(e.message||'Unknown error'));}
   finally{setRemoteBusy(false);}
 };
 const viewRemote=async(item)=>{
   setRemoteBusy(true);setRemoteError('');
   try{
     const res=await fetch('/api/profiles/risk-media?id='+encodeURIComponent(item.id),
       {credentials:'same-origin',cache:'no-store'});
     if(!res.ok)throw Error('Private preview blocked or unavailable ('+res.status+').');
     const url=URL.createObjectURL(await res.blob());
     setOpened({id:item.id,url,mime:item.content_type});
   }catch(e){setRemoteError(e.message||'Unable to retrieve private evidence');}
   finally{setRemoteBusy(false);}
 };
 const deleteRemote=async(item)=>{
   setRemoteBusy(true);setRemoteError('');setRemoteStatus('');
   try{
     const res=await fetch('/api/profiles/risk-media?id='+encodeURIComponent(item.id),
       {method:'DELETE',credentials:'same-origin'});
     const body=await res.json().catch(()=>null);
     if(!res.ok||body?.deleted!==true)throw Error(body?.code||'Deletion failed');
     if(opened?.id===item.id)setOpened(null);
     setRemoteStatus('Evidence deleted from the private R2 store; the staff deletion record is retained.');
     await loadRemote();
   }catch(e){setRemoteError(e.message||'Deletion failed');}
   finally{setRemoteBusy(false);}
 };

 useEffect(()=>()=>preview.forEach(x=>URL.revokeObjectURL(x.url)),[preview]);
 const reload=async()=>{
   try{
     const result=await api('/api/profiles/risk-assessment');
     if(result.staffOnly!==true)throw Error('Staff authorisation required');
     setRecords(result.records||[]);setStatus('Staff records loaded');
   }catch(e){setError(e.message||'Risk records unavailable');}
 };
 useEffect(()=>{void reload();},[]);
 const call=async(body)=>{
   setBusy(true);setError('');setStatus('');
   try{
     const result=await api('/api/profiles/risk-assessment',{
       method:'POST',headers:{'content-type':'application/json'},body:JSON.stringify(body),
     });
     if(!result.staffOnly||!result.record)throw Error('Evidence was not saved');
     setRecords(prev=>[result.record,...prev]);
     setStatus('Staff risk evidence saved. Public publishing has not changed.');
   }catch(e){setError(e.message||'Staff test could not run');}
   finally{setBusy(false);}
 };
 const change=(key,value)=>setRisk(prev=>({...prev,[key]:value}));
 return <section className="profiles-admin-panel" aria-labelledby="staff-risk-title">
   <div className="profiles-admin-panel-heading"><div>
     <span>STAFF ONLY · CUSTOMER OPERATIONS</span>
     <h2 className="govuk-heading-m" id="staff-risk-title">18+ Profiles — Risk Assessment</h2>
     <p className="govuk-body">Internal, staff-authenticated testing and evidence. Never displayed in customer Studio.</p>
   </div></div>
   <div style={{display:'grid',gap:18,padding:22}}>
     <h3 className="govuk-heading-s">Full 18+ experience — private staff interface test</h3>
     <p className="govuk-body">Simulate the proposed biography, photos, videos and creator links using fictional material.
       This preview is local; it does not prove server-side age assurance or media moderation.</p>
     <label className="govuk-label">Visitor condition
       <select className="govuk-select" value={scenario} onChange={e=>setScenario(e.target.value)}>
         {['underage','anonymous','unverified','expired','provider_outage',
           'pending','rejected','revoked','verified_approved'].map(x=>
           <option key={x} value={x}>{x.replaceAll('_',' ')}</option>)}
       </select>
     </label>
     <label className="govuk-label">Authorised sample media (local preview only)
       <input type="file" multiple accept="image/jpeg,image/png,image/webp,video/mp4,video/webm"
         onChange={e=>{
           const files=Array.from(e.target.files||[]).slice(0,4);
           setPreview(files.filter(f=>f.size<40*1024*1024).map(f=>({
             url:URL.createObjectURL(f),mime:f.type,
           })));e.target.value='';
         }}/>
     </label>
     <div style={{border:'1px solid #bec8d3',padding:18}}>
       {scenario==='verified_approved'?<div><strong>STAFF MOCK PROFILE — not published</strong>
         <p className="govuk-body">Example creator biography. Proposed creator link (non-clickable).</p>
         {preview.map((file,i)=>file.mime.startsWith('image/')
           ?<img key={i} src={file.url} alt="Staff test media" style={{maxWidth:220,maxHeight:220}}/>
           :<video key={i} src={file.url} controls style={{maxWidth:220,maxHeight:220}}/>)}
       </div>:<p className="govuk-body" role="status">Access blocked. No restricted media or biography should be visible.</p>}
     </div>
     <h3 className="govuk-heading-s">Actual private media storage — staff test</h3>
     <p className="govuk-body">Use lawful, non-explicit sample images or short videos (8 MB maximum). This sends
       real bytes through the staff-only CRM API to the Profiles R2 backend, not the
       local simulation. Each file can be privately retrieved and permanently deleted.
       It is <strong>not</strong> a creator publishing or content-moderation approval test.</p>
     <label className="govuk-label">Sample file (private, never public)
       <input type="file" accept="image/jpeg,image/png,image/webp,image/gif,video/mp4,video/webm"
         onChange={e=>setRemoteFile(e.target.files?.[0]||null)} />
     </label>
     <div><button className="button govuk-button" type="button" disabled={!remoteFile||remoteBusy}
       onClick={()=>void uploadRemote()}>Upload to private Profiles storage</button>
       <button className="button secondary govuk-button govuk-button--secondary" type="button" disabled={remoteBusy}
         onClick={()=>void loadRemote()}>Refresh stored evidence</button></div>
     {remoteError&&<p className="profiles-admin-error govuk-body" role="alert">{remoteError}</p>}
     {remoteStatus&&<p className="govuk-body" role="status">{remoteStatus}</p>}
     <div style={{display:'grid',gap:8}}>
       {remoteAssets.length===0?<p className="govuk-body">No private evidence files returned by the backend.</p>:
         remoteAssets.map(item=><article key={item.id}
           style={{border:'1px solid #bec8d3',padding:12,display:'flex',gap:12,flexWrap:'wrap'}}>
           <span>{item.content_type} · {(item.byte_size/1024).toFixed(0)} KB · {item.created_at}</span>
           <button type="button" className="button secondary govuk-button govuk-button--secondary" disabled={remoteBusy}
             onClick={()=>void viewRemote(item)}>Retrieve privately</button>
           <button type="button" className="button secondary govuk-button govuk-button--secondary" disabled={remoteBusy}
             onClick={()=>void deleteRemote(item)}>Delete evidence</button>
         </article>)}
     </div>
     {opened&&<div style={{border:'1px solid #bec8d3',padding:16}}>
       <strong>Authenticated staff preview — not public</strong>
       {opened.mime.startsWith('image/')
         ?<img src={opened.url} alt="Private staff assessment evidence" style={{display:'block',maxWidth:'100%',maxHeight:340}}/>
         :<video src={opened.url} controls style={{display:'block',maxWidth:'100%',maxHeight:340}}/>}
       <button className="button secondary govuk-button govuk-button--secondary" type="button" onClick={()=>setOpened(null)}>Close preview</button>
     </div>}
     <h3 className="govuk-heading-s">Actual CRM readiness checks</h3>
     <button type="button" className="button secondary govuk-button govuk-button--secondary" disabled={busy}
       onClick={()=>void call({action:'run_checks'})}>Run measured checks &amp; save evidence</button>
     <h3 className="govuk-heading-s">Record staff findings</h3>
     <form onSubmit={e=>{e.preventDefault();void call(risk);}} style={{display:'grid',gap:10}}>
       <label className="govuk-label">Category
         <select className="govuk-select" value={risk.category} onChange={e=>change('category',e.target.value)}>
           {['age_assurance','illegal_content','child_access','media_processing','moderation',
             'privacy','identity','reporting','access_control','security','other'].map(x=>
             <option key={x} value={x}>{x}</option>)}
         </select>
       </label>
       <label className="govuk-label">Scenario <input className="govuk-input" required value={risk.scenario}
         onChange={e=>change('scenario',e.target.value)} maxLength={80}/></label>
       <label className="govuk-label">Potential harm (minimum 15 characters)<textarea className="govuk-textarea" required maxLength={1500}
         value={risk.harm} onChange={e=>change('harm',e.target.value)}/></label>
       <label className="govuk-label">Affected persons<textarea className="govuk-textarea" maxLength={400} value={risk.affected_persons}
         onChange={e=>change('affected_persons',e.target.value)}/></label>
       {['severity','likelihood','residual_risk'].map(key=><label className="govuk-label" key={key}>{key}
         <select className="govuk-select" value={risk[key]} onChange={e=>change(key,e.target.value)}>
           {['low','medium','high','critical'].map(x=><option key={x}>{x}</option>)}
         </select></label>)}
       {['mitigation','evidence','review_notes'].map(key=><label className="govuk-label" key={key}>{key}
         <textarea className="govuk-textarea" maxLength={2000} value={risk[key]} onChange={e=>change(key,e.target.value)}/>
       </label>)}
       <label className="govuk-label">Outcome <select className="govuk-select" value={risk.outcome} onChange={e=>change('outcome',e.target.value)}>
         {['open','mitigation_required','blocked','ready_for_review'].map(x=>
           <option key={x}>{x}</option>)}
       </select></label>
       <label className="govuk-label">Responsible staff<input className="govuk-input" maxLength={100} value={risk.owner}
         onChange={e=>change('owner',e.target.value)}/></label>
       <label className="govuk-label">Due date<input className="govuk-input" type="date" value={risk.due_date}
         onChange={e=>change('due_date',e.target.value)}/></label>
       <button className="button govuk-button" type="submit" disabled={busy||risk.harm.length<15}>Save staff risk assessment</button>
     </form>
     {error&&<p role="alert" className="profiles-admin-error govuk-body">{error}</p>}
     {status&&<p className="govuk-body" role="status">{status}</p>}
     <h3 className="govuk-heading-s">Staff-only evidence history</h3>
     {records.map(r=><article key={r.assessment_id} style={{border:'1px solid #bec8d3',padding:14}}>
       <strong>{r.category}: {r.scenario}</strong>
       <p className="govuk-body">{r.harm}</p><p className="govuk-body">{r.severity} · {r.outcome} · Staff: {r.tested_by}</p>
       <details><summary>Recorded checks and evidence</summary><pre>{r.test_run_json}</pre></details>
     </article>)}
   </div>
 </section>;
}
